import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-ink bg-paper text-ink">
      <div className="swiss-grid py-8 lg:py-9">
        {/* Brand + pitch */}
        <div className="col-span-12 md:col-span-6 lg:col-span-4">
          <Link to="/" className="text-[1.5rem] font-bold tracking-tight text-ink">
            KODE
          </Link>
          <p className="mt-4 text-body text-ink-70 max-w-measure">
            {t("kode.footer.tagline")}
          </p>
        </div>

        {/* Wallets */}
        <div className="col-span-6 md:col-span-3 lg:col-span-2 lg:col-start-6">
          <span className="swiss-caption">{t("kode.footer.wallets")}</span>
          <ul className="mt-5 flex flex-col gap-3">
            <li><Link to="/wallets/bogowi"    className="text-body link-underline">BOGOWI</Link></li>
            <li><Link to="/wallets/b-web3"    className="text-body link-underline">B:web3 Wallet</Link></li>
            <li><Link to="/wallets/easychain" className="text-body link-underline">EasyChain</Link></li>
            <li><Link to="/wallets/b-did"     className="text-body link-underline">b:did</Link></li>
          </ul>
        </div>

        {/* AI & Data */}
        <div className="col-span-6 md:col-span-3 lg:col-span-2">
          <span className="swiss-caption">{t("kode.footer.aiData")}</span>
          <ul className="mt-5 flex flex-col gap-3">
            <li><Link to="/ai-data/islas-vivas"  className="text-body link-underline">Islas Vivas</Link></li>
            <li><Link to="/ai-data/productivity" className="text-body link-underline">{t("kode.products.productivity.name")}</Link></li>
            <li><Link to="/ai-data/documents"    className="text-body link-underline">{t("kode.products.documents.name")}</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div className="col-span-6 md:col-span-3 lg:col-span-2">
          <span className="swiss-caption">{t("kode.footer.company")}</span>
          <ul className="mt-5 flex flex-col gap-3">
            <li><Link to="/company"       className="text-body link-underline">{t("kode.footer.about")}</Link></li>
            <li><Link to="/case-studies"  className="text-body link-underline">{t("kode.footer.caseStudies")}</Link></li>
            <li><Link to="/company#origin" className="text-body link-underline">{t("kode.footer.origin")}</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="col-span-6 md:col-span-3 lg:col-span-2">
          <span className="swiss-caption">{t("kode.footer.contact")}</span>
          <ul className="mt-5 flex flex-col gap-3">
            <li><a href="mailto:hugo@kode.zone" className="text-body link-underline">hugo@kode.zone</a></li>
            <li><a href="tel:+34636349614" className="text-body link-underline">+34 636 349 614</a></li>
            <li><Link to="/contact" className="text-body link-underline">{t("kode.common.discoveryCall")}</Link></li>
          </ul>
        </div>
      </div>

      {/* Sub-footer */}
      <div className="border-t border-ink-14">
        <div className="swiss-grid py-5">
          <ul className="col-span-12 md:col-span-7 flex flex-wrap items-center gap-x-6 gap-y-2 swiss-caption">
            <li>
              <a
                href="https://www.termsfeed.com/live/a28e543e-b51b-4f2d-9709-7eaf984f097d"
                target="_blank" rel="noreferrer"
                className="text-ink-70 hover:text-ink"
              >
                {t("kode.common.terms")}
              </a>
            </li>
            <li>
              <a
                href="https://intranet.laboralrgpd.com/politicaPrivacidad/index.php?sid=a2dzQnJMWEl3UDgxczN6K2dFZ2pVQT09"
                target="_blank" rel="noreferrer"
                className="text-ink-70 hover:text-ink"
              >
                {t("kode.common.privacy")}
              </a>
            </li>
            <li className="text-ink-50">
              © {new Date().getFullYear()} KODE DE HUGO A PEREZ SOLORZANO S.L · Tenerife
            </li>
          </ul>

          <div className="col-span-12 md:col-span-5 flex md:justify-end items-center gap-4 mt-4 md:mt-0">
            <span className="swiss-caption">{t("Supported by")}</span>
            <div className="flex items-center gap-3">
              <img src="/EU/canariasgob.jpeg" alt="Gobierno de Canarias" className="h-7 w-auto grayscale opacity-80 hover:opacity-100 hover:grayscale-0 transition" />
              <img src="/EU/recuperacion.jpeg" alt="Plan de Recuperación" className="h-7 w-auto grayscale opacity-80 hover:opacity-100 hover:grayscale-0 transition" />
              <img src="/EU/European_Union.png" alt="European Union" className="h-7 w-auto grayscale opacity-80 hover:opacity-100 hover:grayscale-0 transition" />
              <img src="/EU/MITGobWebSIT.webp" alt="MIT Gobierno" className="h-7 w-auto grayscale opacity-80 hover:opacity-100 hover:grayscale-0 transition" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
